import { render, staticRenderFns } from "./ShipToDropdown.vue?vue&type=template&id=5d8ddad6&scoped=true&"
import script from "./ShipToDropdown.vue?vue&type=script&lang=js&"
export * from "./ShipToDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ShipToDropdown.vue?vue&type=style&index=0&id=5d8ddad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ddad6",
  null
  
)

export default component.exports